(function () {
  const CART_ATTRIBUTE_KEY = 'ab_paypal_first';

  async function setCartAttribute(key, value) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [key]: value } })
      });
    } catch (err) {
      console.error('[Shoplift AB] Cart update error:', err);
    }
  }

  async function init() {
    const isVariant = await window.shoplift.isHypothesisActive('019cb3f6-88ce-72f8-9e3b-8dc17326f17c');

    if (isVariant) {
      await setCartAttribute(CART_ATTRIBUTE_KEY, 'true');
      console.log('[Shoplift AB] Variant active — PayPal first attribute set');
    } else {
      await setCartAttribute(CART_ATTRIBUTE_KEY, '');
      console.log('[Shoplift AB] Control — default payment order');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
